import api from "@/api/all_park/all_park"

export default {
    namespaced: true,
    state: {
        authPark: null
    },
    mutations: {
        setAuthPark(state, data) {
            state.authPark = data;
        },
    },
    actions: {
        setAuthPark(context, data) {
            let params = Object.assign({}, {
                type: "StarryExtendTypeBService",
                user_id: sessionStorage.getItem('userId'),
                is_default: true,
                pageSize: 1,
                status: 'IdentityCertifieStatussuccess'
            });
            api.getExtends(params).then(res => {
                if (res.error["err_code"] !== 0) return;
                let obj = res.obj.list[0] || null;
                context.commit("setAuthPark", obj)
            });

        },

    }
}
